<template>
  <v-app id="login" class="application theme--light white">
    <div class="memberContainer">
      <div class="asideLogo"></div>
      <div class="memberAside">
        <div class="aside">
          <div class="asideImg"></div>
          <div class="asideImgCover"></div>
          <div class="asideCont" v-if="$targetMake.isSeller">
            <span class="asideTit">CS運営をされている皆さん、<br>これからは一つの画面で全て<br>管理しませんか？</span>
            <span class="asideTit sub">CS運営の様々な「悩み」を解決する<br>顧客応対ソリューション outaigate</span>
          </div>
          <div class="asideCont" v-else>
            <span class="asideTit">CS運営をされている皆さん、<br>これからは一つの画面で全て<br>管理しませんか？</span>
            <span class="asideTit sub">CS運営の様々な「悩み」を解決する<br>顧客応対ソリューション outaigate</span>
          </div>
        </div>
      </div>
      <div class="memberSection notStep">
        <div class="memberContent">
          <img :src="$targetMake.images.logoSvg" width="348" class="img-responsive cgLogo">
          <div class="memberBox">
            <v-form ref="form" v-model="valid" lazy-validation class="session-form">
              <v-text-field
                outline
                append-icon="person"
                name="loginId"
                id="loginId"
                class="UXinput appendIcon loginId"
                v-model="model.loginId"
                :rules="loginIdRules"
                placeholder="ログインID"
                required
                solo
                v-on:keyup.enter="login">
              </v-text-field>
              <v-text-field
                outline
                name="password"
                id="password"
                class="UXinput notUseErrorIcon appendIcon"
                :append-icon="show ? 'visibility_off' : 'visibility'"
                :type="show ? 'text' : 'password'"
                v-model="model.password"
                :rules="passwordRules"
                placeholder="パスワード"
                required
                solo
                @click:append="show = !show"
                v-on:keyup.enter="login">
              </v-text-field>
            </v-form>
            <v-btn
              block
              dark
              large
              :disabled="!valid"
              @click="login"
              :loading="loading"
              color="#ff8c8c"
              class="UXbtn widthAuto">
              ログイン
            </v-btn>
          </div>
        </div>
        <div class="memberFooter">
          <span class="cursor" @click="join">新規登録</span>
          <div class="line"></div>
          <span class="cursor" @click="findInfo">ログインできない場合</span>
          <div class="line"></div>
          <span class="cursor" @click="privacyInfo">プライバシーポリシー</span>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import eventBus from '@/event_bus'
import moment from 'moment'

export default {
  metaInfo: {
    title: 'ログイン'
  },
  data: () => ({
    valid: true,
    show: false,
    loading: false,
    loginIdRules: [
      v => !!v || 'ログインIDを入力してください。'
      // v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    passwordRules: [
      v => !!v || 'パスワードを入力してください。'
    ],
    model: {
      loginId: '',
      password: ''
    }
  }),
  computed: {},
  destroyed () {
    eventBus.$off('force-login-event')
  },
  mounted () {
    eventBus.$on('force-login-event', (params) => {
      this.$store.dispatch('forceLogin', params)
        .then(result => {
          if (result.data.code === 0) {
            this.login()
          } else if (result.data.code === -1) {
            eventBus.$emit('DialogPopup', {
              useDialog: true,
              messageHTML: `<p class="txt">IDまたはパスワードが間違っています。<br /><span style="color:#919191">5回以上エラーが発生した場合、アカウントがロックされる可能性があります。</span></p>`
            })
          } else {
            this.$alertMsg(result.data.message)
          }
        })
    })
  },
  methods: {
    join () {
      this.$router.push('/member/agreement')
    },
    findInfo () {
      this.$router.push('/member/find_info')
    },
    privacyInfo () {
      window.open('https://developers.google.com/terms/api-services-user-data-policy?hl=ja')
    },
    login () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store.dispatch('login', {
          loginId: this.model.loginId,
          password: this.model.password,
          isAdminLogin: false
        }).then((res) => {
          if (res.isSuccess) {
            this.setTicketListOption()
            this.$router.push('/dashboard')
            this.$logReport.write('[LOGIN]')
          }
          this.loading = false
        })
      }
    },
    setTicketListOption () {
      const key = 'TICKET_LIST_OPTION'
      const option = JSON.parse(localStorage.getItem(key))

      if (option) {
        let startDate = moment(new Date(), 'YYYYMMDD').add(-1, 'month').format('YYYY-MM-DD')
        let recentStartDate = moment(new Date(), 'YYYYMMDD').add(-6, 'days').format('YYYY-MM-DD')
        let endDate = moment(new Date(), 'YYYYMMDD').format('YYYY-MM-DD')

        option.myPage.startDate = startDate
        option.allPage.startDate = startDate
        option.recentUpdatedPage.startDate = recentStartDate
        option.completedPage.startDate = startDate
        option.myPage.endDate = endDate
        option.allPage.endDate = endDate
        option.recentUpdatedPage.endDate = endDate
        option.completedPage.endDate = endDate

        localStorage.setItem(key, JSON.stringify(option))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/member/login.vue